module.exports = __webpack_public_path__ + "static/media/994385.e95d967f.png";